<template>
  <card-container
    :id="pageId"
    no-action
  >
    <template #title>
      Add Member Manually
    </template>

    <template #content>
      <div class="alert alert-warning moved-warning">
        <p class="alert-title">
          Deprecated
        </p>
        This functionality was moved into "User Search" section > "Enroll New User" button
      </div>
    </template>
  </card-container>
</template>

<script setup lang="ts">
const pageId = 'add-member-manually';
</script>

<style lang="scss" scoped>
.moved-warning {
  background-color: #e09b13;
  color: #1a1400;
  font-weight: 600;

  .alert-title {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
